import { Box, Grid, Skeleton } from "@mui/material";
import DetailsImageGrid from "components/listing-detail/image-grid";
import ListingDetails from "components/listing-detail/listing-details";
import ListingLocation from "components/listing-detail/listing-location";
import RelatedSection from "components/listing-detail/related-section";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { searchListingDetails } from "slices/searchListingReducer";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { getAuthUserId } from "utils/auth.util";

const ListingDetail = () => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const { listingDetails, loadingDetails }: any = useAppSelector(
    (state) => state.searchListingReducer
  );

  useEffect(() => {
    dispatch(searchListingDetails({ id: params.id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return (
    <Box sx={{ mb: "30px" }}>
      <Grid container spacing={3}>
        <Grid item md={7} lg={7} xl={7} sm={12} xs={12}>
          {!loadingDetails && (
            <Box>
              <DetailsImageGrid />
            </Box>
          )}
          {loadingDetails && (
            <Box
              sx={{
                display: {
                  md: "block",
                  lg: "block",
                  xl: "block",
                  sm: "none",
                  xs: "none",
                },
                pl: "4%",
                py: "20px",
              }}
            >
              <Grid container spacing={2}>
                <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      height: "350px",
                      width: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </Grid>
                <Grid item md={6} lg={6} xl={6} sm={12} xs={12}>
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      height: "350px",
                      width: "100%",
                      borderRadius: "10px",
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
        <Grid item md={5} lg={5} xl={5} sm={12} xs={12}>
          <Box>
            <ListingDetails />
          </Box>
        </Grid>
        {(listingDetails?.related?.length > 0 ||
          listingDetails?.user?.firebase_id !== getAuthUserId()) && (
          <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
            {!loadingDetails && <RelatedSection />}
          </Grid>
        )}
        {!loadingDetails && (
          <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
            <ListingLocation />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default ListingDetail;
